import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

/**
 * "Sistema Atualizado" na navbar: existe nota de atualização mais nova do
 * que a última que este usuário viu (`operacional.usuarios.
 * ultima_patch_note_vista`, comparado em GET /get/patch-notes/status)?
 *
 * `esconder()` some com o aviso na hora do clique, sem esperar a navegação —
 * a tela de notas já marca como vista de verdade (post/patch-notes/marcar-visto)
 * assim que abre.
 */
export function usePatchNotesStatus() {
  const [temNovidade, setTemNovidade] = useState(false);

  const verificar = useCallback(async () => {
    const token = localStorage.getItem('token');
    const parsedURL = localStorage.getItem('urlParsed');
    if (!token || !parsedURL) return;
    try {
      const { data } = await axios.get(`${parsedURL}get/patch-notes/status`, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 8000,
      });
      setTemNovidade(Boolean(data?.content?.tem_novidade));
    } catch (_) {
      // API fora do ar não deve gerar aviso falso nem travar a navbar.
    }
  }, []);

  useEffect(() => { verificar(); }, [verificar]);

  const esconder = () => setTemNovidade(false);

  return { temNovidade, esconder };
}
